export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13020.d6d635a4.jpg";